import axios from "axios";

export function logincheck(user_id, mobiledeviceid) {

	  let data = {
		user_id: user_id,
		deviceid: mobiledeviceid
	  }
  
	return axios.post(process.env.REACT_APP_NODE_ENV + '/api/web/customerlogincheck', data, {
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		}
	});
  
 }